module.exports = __webpack_public_path__ + "img/american-express.f44839ba.png";